import { AuthenticationService } from 'src/app/core/services/auth.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemParams, DgActionColumnWidth, DgAlignment, DgColumnDataType, DgColumnWidths, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { CountryGroupCountriesEmbeddedComponent } from '../country-group-countries/country-group-countries.component';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { DgTab } from 'src/app/core/interfaces/datagrid/dg-tab';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { firstValueFrom } from 'rxjs';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';


const apiPath             =environment.eSimApi+eSimApiPaths.CountryGroups;
const exportFilenameSuffix="Country-Groups-Data";
const popUpTitle          ="Country Groups";

@Component({
  selector: 'country-groups',
  templateUrl: './country-groups.component.html',
  styleUrls: ['./country-groups.component.scss']
})

export class CountryGroupsEmbeddedComponent implements OnInit {

  @Input() companyId: number | undefined;

  @Output() addButtonClick   : EventEmitter<void>   =new EventEmitter<void>    ();
  @Output() deleteButtonClick: EventEmitter<number> =new EventEmitter<number>  ();
  @Output() editButtonClick  : EventEmitter<number> =new EventEmitter<number>  ();
  @Output() viewButtonClick  : EventEmitter<number> =new EventEmitter<number>  ();

  @ViewChild('gridView',       { static: false }) gridView!       : GridViewComponent;
  @ViewChild('groupCountries'                   ) groupCountries! : CountryGroupCountriesEmbeddedComponent;

  private alignmentReloadDone: boolean=false;
  private gridViewDefaults!: GridViewDefaults;

  public curUser           : SystemUserDTO;
  public dgApiPath!        : DgApiPath | undefined;
  public dgActionColumn!   : DgActionColumn | undefined;
  public dgColumns!        : Array<DgColumn>;
  public dgPopup!          : DgPopup | undefined;
  public dgProperties!     : DgProperties | undefined;
  public dgTabs!           : Array<DgTab>;
  public gotDgProperties   : boolean=false;

  public activeTab                  : number=1;
  public navItemLog_All             : number=1;
  public navItemLog_MyGroups        : number=2;
  public navItemLog_SharedByUtelize : number=3;
  private tabFilterApplied          : boolean=false;

  constructor(
    private authenticationService     : AuthenticationService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private encryptionService         : EncryptionService,
    private exceptionsService         : ExceptionsService,
    private gridViewService           : GridViewService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public async ngOnInit(): Promise<void> {
    try {
      if (this.companyId == undefined) {
        throw new Error("CountryGroupsEmbeddedComponent - CompanyId cannot be determined");
      }

      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgPopup();
      this.setUpDgProperties();
      this.setUpDgTabs();

      this.gotDgProperties=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async setUpDgApiPaths(): Promise<void> {
    try {
      this.dgApiPath            =this.gridViewDefaults.setUpDgApiPaths(apiPath);
      this.dgApiPath!.refreshGet=() => this.setDgApiPathGet(false);

      await this.setDgApiPathGet(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn                          =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.allowAdding             =false;
      this.dgActionColumn!.allowDeleting           =true;
      this.dgActionColumn!.allowUpdating           =true;
      this.dgActionColumn!.allowMore               =true;
      this.dgActionColumn!.cellTemplate            ="DataDrivenButtons";
      this.dgActionColumn!.deleteIcon              ="assets/images/_suresim/Button Remove 55x23.png";
      this.dgActionColumn!.moreIcon                ="assets/images/_suresim/Button View 55x23.png";
      this.dgActionColumn!.deleteRowButtonCondition=(data:any) => this.canManageRow(data);
      this.dgActionColumn!.updateRowButtonCondition=(data:any) => this.canManageRow(data);
      this.dgActionColumn!.moreRowButtonCondition  =(data:any) => !this.canManageRow(data);
      this.dgActionColumn!.overrideDelete          =true;
      this.dgActionColumn!.visible                 =true;
      this.dgActionColumn!.width                   =DgActionColumnWidth.twoButtonsWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private isUtelizePlatformContext(): boolean {
    return this.curUser.isUtelize && Math.abs(this.companyId ?? 0) == this.curUser.companyId;
  }

  private canManageRow(data: any): boolean {
    try {
      if (data == null)
        return true;

      if (data.companyID == null || data.companyID == undefined) {
        return this.isUtelizePlatformContext();
      }

      return true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopup!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties() {
    try {
      this.dgProperties                    =this.gridViewDefaults.setUpDgProperties("", exportFilenameSuffix + "-" + (this.companyId ?? -1));
      this.dgProperties!.focusedRowUnselect=false;
      this.dgProperties!.initialTab        =this.navItemLog_All;
      this.dgProperties!.masterDetail      =true;
      this.dgProperties!.remoteOperations  =false;
      this.dgProperties!.showAddButton     =true;
      this.dgProperties!.showTabs          =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns() {
    try {
      let dgColumn: DgColumn | undefined;

      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumns       =[dgColumn!];

      //GroupName
      dgColumn       =this.gridViewDefaults.setUpDgColumn("groupName", "Group", "", DgColumnDataType.string);
      dgColumn!.width =220;
      this.dgColumns.push(dgColumn!);

      //CountryCount
      dgColumn       =this.gridViewDefaults.setUpDgColumn("countryCount", "Included Countries", "", DgColumnDataType.number);
      dgColumn!.width =160;
      this.dgColumns.push(dgColumn!);

      //Owner (the customer the group was created for, or Utelize for all-customers groups)
      dgColumn       =this.gridViewDefaults.setUpDgColumn("owner", "Owner", "", DgColumnDataType.string);
      dgColumn!.width =200;
      this.dgColumns.push(dgColumn!);

      //AllCustomers - reflects the "Visible to all customers" switch; only shown in the Utelize / SureSIM Platform context
      dgColumn             =this.gridViewDefaults.setUpDgColumn("allCustomers", "All Customers", false, DgColumnDataType.boolean);
      dgColumn!.alignment  =DgAlignment.center;
      dgColumn!.gridVisible=this.isUtelizePlatformContext();
      dgColumn!.width      =140;
      this.dgColumns.push(dgColumn!);

      //AlertCount - rendered as a count badge + label ("3 rules" / "1 rule" / "Not used yet")
      dgColumn                  =this.gridViewDefaults.setUpDgColumn("alertCount", "Used In Rules", "", DgColumnDataType.number);
      dgColumn!.cellTemplate    ="alertCount";
      dgColumn!.cellTemplateType="countBadge";
      dgColumn!.width           =160;
      this.dgColumns.push(dgColumn!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgTabs() {
    try {
      let dgTab: DgTab | undefined;

      dgTab        =this.gridViewDefaults.setUpDgTab(this.navItemLog_All, "All");
      this.dgTabs  =[dgTab!];

      dgTab        =this.gridViewDefaults.setUpDgTab(this.navItemLog_MyGroups, "My Groups");
      this.dgTabs.push(dgTab!);

      dgTab        =this.gridViewDefaults.setUpDgTab(this.navItemLog_SharedByUtelize, "Shared By SureSim");
      this.dgTabs.push(dgTab!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onTabChange(event: any) {
    try {
      this.activeTab = <number>event;
      this.reapplyTabFilter();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onContentReady(event: any) {
    try {
      if (!this.tabFilterApplied) {
        this.tabFilterApplied = true;
        this.reapplyTabFilter();
      }

      //RBW_20260611 - A fresh DevExtreme master-detail grid renders its fixed-column and main-table rows 1px out of
      //sync, drifting the expand arrows further down the grid. After the first data load, reassign the client-side data to a fresh
      //copy of itself (same data, new reference, no extra server call) to trigger an aligned rebuild. Guarded so it only runs once.
      if (!this.alignmentReloadDone && this.gridView?.clientSideProcessingModels?.length) {
        this.alignmentReloadDone = true;
        this.gridView.clientSideProcessingModels = [...this.gridView.clientSideProcessingModels];
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridRowExpanding(e: any) {
    try {
      const group = this.gridView.clientSideProcessingModels?.find(x => x.id == e);

      if (group != undefined)
        this.groupCountries.showCountries(group.id);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private reapplyTabFilter() {
    try {
      const gridInstance = this.gridView?.dataGrid?.instance;
      if (gridInstance == undefined)
        return;

      if (this.activeTab == this.navItemLog_MyGroups) {
        gridInstance.filter(['allCustomers', '=', false]);
      } else if (this.activeTab == this.navItemLog_SharedByUtelize) {
        gridInstance.filter(['allCustomers', '=', true]);
      } else {
        gridInstance.filter(null);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridAddButtonClick(e:any) {
    try {
      this.addButtonClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridDeleteButtonClick(e:any) {
    try {
      let groupId: number | undefined = e.row.data["id"];

      if (groupId==undefined || <number>groupId<=0) {
        throw new Error("CountryGroupsComponent.gridDeleteButtonClick().groupId cannot be determined");
      }

      this.deleteButtonClick.emit(groupId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridEditButtonClick(e:any) {
    try {
      let groupId: number | undefined = e.row.data["id"];

      if (groupId==undefined || <number>groupId<=0) {
        throw new Error("CountryGroupsComponent.gridEditButtonClick().groupId cannot be determined");
      }

      this.editButtonClick.emit(groupId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridMoreButtonClick(e:any) {
    try {
      let groupId: number | undefined = e.row.data["id"];

      if (groupId==undefined || <number>groupId<=0) {
        throw new Error("CountryGroupsComponent.gridMoreButtonClick().groupId cannot be determined");
      }

      this.viewButtonClick.emit(groupId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridRowClick(e:any) {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshGrid() {
    this.setDgApiPathGet(true);
  }

  public async setDgApiPathGet(refreshGrid: boolean): Promise<void> {
    try {
      if (this.companyId == undefined)
        throw new Error("CountryGroupsComponent - CompanyId cannot be determined");

      const companyIdToEncrypt=<string>(this.companyId ?? -1).toString();
      const companyIdEncResult=await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(companyIdToEncrypt, true));
      const companyIdEncSS    =companyIdEncResult.result;

      const allCustomersColumn=this.dgColumns?.find(c => c.dataField == "allCustomers");
      if (allCustomersColumn != undefined)
        allCustomersColumn.gridVisible=this.isUtelizePlatformContext();

      this.dgApiPath!.get=environment.eSimApi +
                          eSimApiPaths.CountryGroups + '/' +
                          eSimApiPaths.CountryGroupsGetCountryGroupsForCompany +
                          "?companyIdEncSS=" + companyIdEncSS;

      if (refreshGrid) {
        this.tabFilterApplied          =false;
        this.gridViewService.apiPathGet=this.dgApiPath!.get;
        this.gridView.refreshData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
